import { useMutation } from "react-query";
import { Button, Container, Form, Grid, Stack, Text } from "basis";
import { postHref } from "library/api";
import { CreditCard } from "../CreditCard/CreditCard";
import { OneTimeCode } from "../OneTimeCode/OneTimeCode";
import { BpayDetails } from "./BpayDetails";
import { EVENTS } from "./bpayReducer";

const initialValues = {
  oneTimeCode: "",
};

function BpayOneTimeCode({ state, dispatch }) {
  const {
    fromAccount,
    biller,
    referenceNumber,
    amount,
    paymentDate,
    maskedMobileNumber,
    verifyOtpAction,
    resendOtpAction,
  } = state;
  const { cardName, cardEndsWith } = fromAccount.data;
  const oneTimeCodeMutation = useMutation(
    ({ oneTimeCode }) => postHref(verifyOtpAction.href, { otp: oneTimeCode }),
    {
      onSuccess: () => {
        dispatch({
          type: EVENTS.ONE_TIME_CODE_VERIFIED_SUCCESSFULLY,
          receiptNumber: "7362344", // Hardcoded for now, will come from the API later.
        });
      },
      onError: (error, { setErrors }) => {
        const errorType = error.response?.data?.type ?? null;

        switch (errorType) {
          case "BAD_REQUEST": {
            setErrors({
              oneTimeCode: "Invalid code",
            });
            break;
          }

          default: {
            dispatch({
              type: EVENTS.ONE_TIME_CODE_VERIFICATION_FAILED,
            });
          }
        }
      },
    },
  );
  const onSubmit = ({ errors, values, setErrors }) => {
    if (Object.keys(errors).length === 0) {
      const { oneTimeCode } = values;

      oneTimeCodeMutation.mutate({
        oneTimeCode,
        setErrors,
      });
    }
  };

  return (
    <Form initialValues={initialValues} onSubmit={onSubmit}>
      <Stack gap="8">
        <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="2">
          <Grid.Item colSpan="all" colSpan-sm="0-1">
            <Text>
              <strong>From account</strong>
            </Text>
          </Grid.Item>
          <Grid.Item colSpan="all" colSpan-sm="2-7">
            <Container bg="grey.t05" padding="4">
              <CreditCard cardName={cardName} cardEndsWith={cardEndsWith} />
            </Container>
          </Grid.Item>
        </Grid>
        <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="2">
          <Grid.Item colSpan="all" colSpan-sm="0-1">
            <Text>
              <strong>Payment details</strong>
            </Text>
          </Grid.Item>
          <Grid.Item colSpan="all" colSpan-sm="2-7">
            <BpayDetails
              biller={biller}
              referenceNumber={referenceNumber}
              amount={amount}
              paymentDate={paymentDate}
            />
          </Grid.Item>
        </Grid>
        <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="2">
          <Grid.Item colSpan="all" colSpan-sm="0-1">
            <Text>
              <strong>Verify your identity</strong>
            </Text>
          </Grid.Item>
          <Grid.Item colSpan="all" colSpan-sm="2-7">
            <Stack gap="8">
              <OneTimeCode
                codeLength={6}
                otpRecipient={maskedMobileNumber}
                resendMutationFn={() => postHref(resendOtpAction.href)}
                onResendCodeError={() => {
                  dispatch({
                    type: "ONE_TIME_CODE_RESEND_FAILED",
                  });
                }}
              />
              <Container>
                <Button
                  type="submit"
                  width="calc(50% - 16px)"
                  width-xs="152"
                  loading={oneTimeCodeMutation.isLoading}
                >
                  Pay
                </Button>
                <Button
                  variant="secondary"
                  width="calc(50% - 16px)"
                  width-xs="152"
                  margin="0 0 0 8"
                  disabled={oneTimeCodeMutation.isLoading}
                  onClick={() => {
                    dispatch({
                      type: EVENTS.BACK_CLICKED,
                    });
                  }}
                >
                  Back
                </Button>
              </Container>
            </Stack>
          </Grid.Item>
        </Grid>
      </Stack>
    </Form>
  );
}

export { BpayOneTimeCode };
